import React, { Component } from 'react';
import QuickSearchResult from './QuickSearchResult';
import { translate } from '../Services/translation';

class QuickSearch extends Component {
    focusOnInput() {
        setTimeout(() => {
            this.searchInput && this.searchInput.focus();
        }, 0);
    }

    handleBlur(e) {
        const nextFocus = e.relatedTarget;
        if (this.containerRef && nextFocus && this.containerRef.contains(nextFocus)) {
            return;
        }
        this.props.onBlur && this.props.onBlur();
    }

    handleKeyDown(e) {
        if (e.key === 'Escape') {
            const { showResult, hideResult, showFullForm, toggleShowFullForm } = this.props;
            if (showResult && hideResult) hideResult();
            if (showFullForm && toggleShowFullForm) toggleShowFullForm();
            this.searchInput && this.searchInput.blur();
            return;
        }
        this.props.onKeyDown(e, { searchUrl: this.props.searchUrl });
    }

    render () {
        const { query, result, showResult, showFullForm, onSearch, toggleShowFullForm, hideResult, selectedItem, searchUrl } = this.props;
        const showClearIcon = !!query || !!showResult;
        return (
            <div
                className="quick-search"
                role="search"
                ref={(el) => { this.containerRef = el; }}
                onBlur={(e) => this.handleBlur(e)}
            >
                <a className="quick-search__link--block" onClick={e => {toggleShowFullForm(); this.focusOnInput()}}>
                    <img src="/ui/images/right-icon.svg" alt={translate('general.search')} width="24" height="24" />
                    <span className="quick-search__title">{translate('general.search')}</span>
                </a>
                <div className={`quick-search__form ${showFullForm ? 'quick-search__form--force-show' : ''}`} role="search">
                    <div className="quick-search__input--wrapper" onClick={() => this.focusOnInput()} style={{ cursor: 'text' }}>
                        <img className="quick-search__input--search-icon" src="/ui/images/right-icon.svg" alt={translate('general.search')} width="24" height="24" />
                        <input className="quick-search__input" type="text" placeholder={translate('quicksearch.search-placeholder')}
                        autoComplete="off" value={decodeURIComponent(query)} onChange={event => onSearch(encodeURIComponent(event.target.value))}
                        onKeyDown={(e) => this.handleKeyDown(e)} ref={(input) => { this.searchInput = input; }} />
                        <button
                            type="button"
                            className="quick-search__clear-icon"
                            aria-label={translate('quicksearch.clear')}
                            tabIndex={showClearIcon ? 0 : -1}
                            style={{ visibility: showClearIcon ? 'visible' : 'hidden' }}
                            aria-hidden={!showClearIcon}
                            onClick={e => { e.stopPropagation(); if (showClearIcon) { onSearch(""); hideResult && hideResult(); this.focusOnInput(); } }}
                        >
                            <img src="/ui/images/x-icon.svg" alt="" width="24" height="24" />
                        </button>
                    </div>
                    {showResult && <QuickSearchResult result={result} selectedItem={selectedItem} searchUrl={searchUrl}/>}
                </div>
            </div>
        )
    }
}

export default QuickSearch;